import React from "react";
import t from "Utils/translation";
import WarningBanner from "Components/warningBanner/WarningBanner";
import cx from "classnames";

const InfoRect = ({ label, value, width = "152" }) => (
  <>
    <rect id="Rectangle" stroke="#E8E8E8" x="0" y="0" width={width} height="71" rx="5"></rect>
    <text
      x={width / 2}
      y="50"
      textAnchor="middle"
      alignmentBaseline="middle"
      fill="#333333"
      id="label"
      opacity="0.5"
      fontFamily="SourceSansPro-Regular, Source Sans Pro"
      fontSize="12"
      fontWeight="normal"
    >
      {label}
    </text>
    <text
      x={width / 2}
      y="30"
      id="number"
      fontFamily="SourceSansPro-SemiBold, Source Sans Pro"
      fontSize="16"
      fontWeight="500"
      fill="#333333"
      textAnchor="middle"
      alignmentBaseline="middle"
    >
      {value}
    </text>
  </>
);

const SmallDashboardAnalytics = ({
  analyticsData: { accepted, enqueued, suppressed, delivered, bounces, unavailable } = {},
}) => {
  return (
    <svg
      viewBox="0 0 390 427"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={cx("max-w-[450px]", {
        "opacity-40": unavailable,
      })}
    >
      <title>Artboard</title>
      <g id="Artboard" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="number-" transform="translate(78, 14)">
          <InfoRect label={t("delivery.dashboardActivities.accepted")} value={accepted} width="229" />
        </g>
        <g id="number-" transform="translate(78, 118)">
          <InfoRect label={t("delivery.dashboardActivities.enqueued")} value={enqueued} width="229" />
        </g>
        <line x1="193.5" y1="86.5" x2="193.5" y2="118.5" id="Line-5" stroke="#979797" strokeLinecap="square"></line>
        <circle id="Oval" stroke="#979797" fill="#D8D8D8" cx="193.5" cy="118.5" r="4"></circle>
        <g id="Group-3" transform="translate(78, 341)">
          <InfoRect label={t("delivery.dashboardActivities.delivered")} value={delivered} width="229" />
        </g>
        <g id="Group-4" transform="translate(14, 253)">
          <InfoRect label={t("delivery.dashboardActivities.suppressed")} value={suppressed} />
        </g>
        <g id="Group-2" transform="translate(220, 252)">
          <InfoRect label={t("delivery.dashboardActivities.bounces")} value={bounces} />
        </g>
        <line
          x1="194.5"
          y1="190.399533"
          x2="194.5"
          y2="340.600467"
          id="Line-5"
          stroke="#979797"
          strokeLinecap="square"
        ></line>
        <path
          d="M194.5,190.299065 L194.5,215.944975 C194.5,221.467823 190.022847,225.944975 184.5,225.944975 L100.5,225.944975 C94.9771525,225.944975 90.5,230.422128 90.5,235.944975 L90.5,252.504673 L90.5,252.504673"
          id="Line"
          stroke="#979797"
          strokeLinecap="square"
        ></path>
        <path
          d="M296.5,190.299065 L296.5,215.944975 C296.5,221.467823 292.022847,225.944975 286.5,225.944975 L204.5,225.944975 C198.977153,225.944975 194.5,230.422128 194.5,235.944975 L194.5,252.504673 L194.5,252.504673"
          id="Line"
          stroke="#979797"
          strokeLinecap="square"
          transform="translate(245.5, 221.4019) scale(-1, 1) translate(-245.5, -221.4019)"
        ></path>
        <circle id="Oval" stroke="#979797" fill="#D8D8D8" cx="194.5" cy="341.5" r="4"></circle>
        <circle id="Oval" stroke="#979797" fill="#D8D8D8" cx="90.5" cy="251.5" r="4"></circle>
        <circle id="Oval" stroke="#979797" fill="#D8D8D8" cx="296.5" cy="251.5" r="4"></circle>
      </g>
    </svg>
  );
};

const DashboardAnalytics = ({
  width = "100%",
  height = "100%",
  analyticsData: { accepted, enqueued, suppressed, delivered, bounces, unavailable } = {},
  isSmall,
}) => {
  return (
    <div className="relative max-w-[500px] w-full">
      {unavailable && (
        <WarningBanner
          color="yellow"
          msg={t("delivery.dashboardActivities.unavailable")}
          className="absolute left-[50%] top-[50%] transform translate-x-[-50%] translate-y-[-50%] w-max z-10"
        />
      )}

      {isSmall ? (
        <SmallDashboardAnalytics analyticsData={{ accepted, enqueued, suppressed, delivered, bounces, unavailable }} />
      ) : (
        <svg
          width={width}
          height={height}
          viewBox="0 0 476 330"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          className={cx({
            "opacity-40": unavailable,
          })}
        >
          <g id="email-delivery-/-utenze" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Utenze-/-dettagli-/-dashboard---abbonamento-FREE" transform="translate(-666, -558)">
              <g id="Group-7" transform="translate(666, 558)">
                <g id="Group-3" transform="translate(162, 258)">
                  <InfoRect label={t("delivery.dashboardActivities.delivered")} value={delivered} />
                </g>
                <g id="Group-4" transform="translate(0, 238)">
                  <InfoRect label={t("delivery.dashboardActivities.suppressed")} value={suppressed} />
                </g>
                <g id="Group-2" transform="translate(323, 238)">
                  <InfoRect label={t("delivery.dashboardActivities.bounces")} value={bounces} />
                </g>
                <g id="number-" transform="translate(123, 0)">
                  <InfoRect width="229" label={t("delivery.dashboardActivities.accepted")} value={accepted} />
                </g>
                <g id="number-" transform="translate(123, 104)">
                  <InfoRect width="229" label={t("delivery.dashboardActivities.enqueued")} value={enqueued} />
                </g>
                <line
                  x1="238.5"
                  y1="72.5"
                  x2="238.5"
                  y2="104.5"
                  id="Line-5"
                  stroke="#979797"
                  strokeLinecap="square"
                ></line>
                <circle id="Oval" stroke="#979797" fill="#D8D8D8" cx="238.5" cy="104.5" r="4"></circle>
                <line
                  x1="238.5"
                  y1="176.299065"
                  x2="238.5"
                  y2="253.5"
                  id="Line-5"
                  stroke="#979797"
                  strokeLinecap="square"
                ></line>
                <path
                  d="M238.5,176.299065 L238.5,201.944975 C238.5,207.467823 234.022847,211.944975 228.5,211.944975 L86.5,211.944975 C80.9771525,211.944975 76.5,216.422128 76.5,221.944975 L76.5,238.504673 L76.5,238.504673"
                  id="Line"
                  stroke="#979797"
                  strokeLinecap="square"
                ></path>
                <path
                  d="M400.5,176.299065 L400.5,201.944975 C400.5,207.467823 396.022847,211.944975 390.5,211.944975 L248.5,211.944975 C242.977153,211.944975 238.5,216.422128 238.5,221.944975 L238.5,238.504673 L238.5,238.504673"
                  id="Line"
                  stroke="#979797"
                  strokeLinecap="square"
                  transform="translate(319.5, 207.4019) scale(-1, 1) translate(-319.5, -207.4019)"
                ></path>
                <circle id="Oval" stroke="#979797" fill="#D8D8D8" cx="238.5" cy="258.5" r="4"></circle>
                <circle id="Oval" stroke="#979797" fill="#D8D8D8" cx="76.5" cy="238.5" r="4"></circle>
                <circle id="Oval" stroke="#979797" fill="#D8D8D8" cx="400.5" cy="238.5" r="4"></circle>
              </g>
            </g>
          </g>
        </svg>
      )}
    </div>
  );
};

export default DashboardAnalytics;
